interface PasswordResetRequest {
  email: string;
  tenantId: string;
}

interface PasswordResetBody {
  token: string;
  newPassword: string;
  tenantId: string;
}

interface ErrorResponse {
  error: string;
}

export const requestPasswordReset = async (data: PasswordResetRequest): Promise<void> => {
  const response = await fetch(`${process.env.REACT_APP_API_URL}/auth/password/reset/request`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json"
    },
    credentials: 'include',
    body: JSON.stringify(data),
  });

  if (!response.ok) {
    throw new Error('Failed to request password reset');
  }
};

export const resetPassword = async (data: PasswordResetBody): Promise<void> => {
  const response = await fetch(`${process.env.REACT_APP_API_URL}/auth/password/reset`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json"
    },
    credentials: 'include',
    body: JSON.stringify(data),
  });

  if (!response.ok) {
    const errorData = await response.json() as ErrorResponse;
    if (errorData.error === "Invalid reset token") {
      throw new Error("Reset link is invalid, please request a new one");
    }
    throw new Error("Failed to reset password");
  }
}; 